import uploadModal from './uploadModal.vue'
export default uploadModal
